import {CustomEase} from 'gsap/all'
import gsap from 'gsap'

gsap.registerPlugin(CustomEase)

export const customEase = CustomEase.create("custom", "M0,0,C0,0,0.01,0.133,0.032,0.236,0.037,0.261,0.058,0.319,0.07,0.34,0.077,0.355,0.167,0.538,0.246,0.32,0.272,0.248,0.282,0.16,0.362,0.122,0.448,0.08,0.584,0.184,0.672,0.196,0.876,0.223,1,0,1,0")

export const customEaseOpacity = CustomEase.create("custom", "M0,0,C0,0,0.005,0.125,0.02,0.199,0.033,0.268,0.047,0.314,0.075,0.379,0.102,0.446,0.247,0.65,0.3,0.7,0.362,0.758,0.425,0.8,0.5,0.8,0.602,0.8,0.647,0.756,0.7,0.7,0.75,0.646,0.89,0.462,0.922,0.382,0.945,0.323,0.976,0.245,0.98,0.2,0.99,0.082,1,0,1,0")